import cn from 'clsx'

import { Button, BlogTile } from 'shared-components'

import s from './BlogStrip.module.sass'

function BlogStrip({ title, hideBottomBorder, posts }: any) {
    return (
        <section className={cn(s.BlogStrip, hideBottomBorder && s.HideBottomBorder)}>
            <div className={cn(s.IntroCont, 'container')}>
                <div className={s.Intro}>
                    <h2>{title}</h2>
                    <Button url="/news" title="View all" />
                </div>
            </div>
            <div className={cn(s.Cont, 'container')}>
                <div className={s.Grid}>
                    {posts?.map((post: any, index: number) => <BlogTile post={post} key={index} />)}
                </div>
            </div>
        </section>
    )
}

export default BlogStrip
